import React from 'react';
import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { adminCombineSx, adminSectionHeadingSx } from '../../styles/adminComponentStyles';

type AdminSectionHeadingProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

const AdminSectionHeading: React.FC<AdminSectionHeadingProps> = ({ children, sx }) => (
  <Typography sx={adminCombineSx(adminSectionHeadingSx, sx)}>
    {children}
  </Typography>
);

export default React.memo(AdminSectionHeading);
